import { useBaseQuery } from '@aibees/shared/http';
import { useWorkspace } from '@aibees/shared/workspace';
import { TAX_ID } from '@aibees/shared/workspace/constants/endpoints';
import { BrowseTaxIdResponse } from './types';

export function useBrowseTaxIdApi() {
  const workspaceId = useWorkspace()?.id ?? '';

  return useBaseQuery<void, BrowseTaxIdResponse>(
    [useBrowseTaxIdApi.name, workspaceId],
    {
      url: TAX_ID.replace(':customerId', workspaceId),
    },
    {
      enabled: Boolean(workspaceId),
    }
  );
}
